/**
 * Trim url
 */
export const trimURL = (url: string) => {
  const length = url?.length ?? 0;
  const urlObject = new URL(url);

  if (length > 10) {
    return `${urlObject.origin}/${urlObject.pathname?.substring(0, 10)}...`;
  }

  return url ?? "";
};
